import React, { ReactNode } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button as MaterialButton } from "@material-ui/core";
import clsx from "clsx";
import { colors } from "../../theme";
import { Link as RouterLink } from "react-router-dom";

interface Props {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  linkTo?: string;
  type?: any;
  disabled?: boolean;
}

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: "none",
    color: colors.BUTTON_TEXT,
    height: "37px",
    backgroundColor: colors.BUTTON_BG,
    fontSize: "16px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    borderRadius: "3px",
    "&:hover": {
      backgroundColor: colors.BUTTON_BG,
    },
  },
}));

export default function Button({
  children,
  className,
  onClick,
  linkTo,
  type = "button",
  disabled = false,
}: Props) {
  const classes = useStyles();

  if (linkTo)
    return (
      <MaterialButton
        className={clsx(classes.button, className)}
        onClick={onClick}
        to={linkTo}
        component={RouterLink}
        type={type}
        disabled={disabled}
      >
        {children}
      </MaterialButton>
    );

  return (
    <MaterialButton
      className={clsx(classes.button, className)}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      {children}
    </MaterialButton>
  );
}
